import WaitingRoomActionsContainer from './WaitingRoomActionsContainer';

export default WaitingRoomActionsContainer;
